<template>
    <div class="map-wrapper overflow-hidden" :id="id + '-fullscreen'">
        <map-loading :loading="loadingMap" />
        <div id="map-popup" class="ol-popup"></div>
        <div :class="mapClass" @click="onClickMap" :id="id">
            <!-- Feedback Options -->
            <MapFeedbackoptionsControl
                :moduleCode="moduleCode"
                :showBtnMap="false"/>

            <!-- Expand / Collapse -->
            <MapExpandcollapseControl
                v-if="activeExpandCollapse"
                :posBtnMap="mapButtons.expandcollapse.position"
                :idxBtnMap="mapButtons.expandcollapse.order"
                :showLabelBtnMap="mapButtons.expandcollapse.showLabel"
                :collapsed="initialCollapsedExpandCollapse"
                :showButtonOnActionMap="false"
                :moduleCode="moduleCode"/>

            <!-- Zoom -->
            <MapZoomControl
                v-if="enableZoom"
                :posBtnMap="mapButtons.zoom.position"
                :idxBtnMap="mapButtons.zoom.order"
                :asGroup="mapButtons.zoom.group"
                :moduleCode="moduleCode"/>
            <!-- Attribution -->
            <MapAttributionControl
                v-if="enableAttribution"
                :posBtnMap="mapButtons.attribution.position"
                :subPosBtnMap="mapButtons.attribution.subposition"
                :idxBtnMap="mapButtons.attribution.order"
                :moduleCode="moduleCode"/>
            <!-- ScaleLine -->
            <MapScalelineControl
                v-if="enableScaleLine"
                :posBtnMap="mapButtons.scaleline.position"
                :subPosBtnMap="mapButtons.scaleline.subposition"
                :idxBtnMap="mapButtons.scaleline.order"
                :moduleCode="moduleCode"/>
            <!-- ScaleBox -->
            <MapScaleboxControl
                v-if="enableScaleBox"
                :posBtnMap="mapButtons.scalebox.position"
                :subPosBtnMap="mapButtons.scalebox.subposition"
                :idxBtnMap="mapButtons.scalebox.order"
                :moduleCode="moduleCode"/>
            <!-- MousePosition -->
            <MapMousepositionControl
                v-if="enableMousePosition"
                :posBtnMap="mapButtons.mouseposition.position"
                :subPosBtnMap="mapButtons.mouseposition.subposition"
                :idxBtnMap="mapButtons.mouseposition.order"
                :moduleCode="moduleCode"/>
            <!-- Geolocation -->
            <MapGeolocationControl
                v-if="enableGeoLocation"
                :posBtnMap="mapButtons.geolocation.position"
                :idxBtnMap="mapButtons.geolocation.order"
                :moduleCode="moduleCode"/>
            <!-- FullScreen -->
            <MapFullscreenControl
                v-if="enableFullScreen"
                :posBtnMap="mapButtons.fullscreen.position"
                :idxBtnMap="mapButtons.fullscreen.order"
                :moduleCode="moduleCode"/>
            <!-- StreetView -->
            <MapStreeviewControl
                v-if="enableStreetView"
                :posBtnMap="mapButtons.streetview.position"
                :idxBtnMap="mapButtons.streetview.order"
                :moduleCode="moduleCode"/>
            <!-- Measure -->
            <MapMeasureControl
                v-if="enableMeasure"
                :posBtnMap="mapButtons.measure.position"
                :idxBtnMap="mapButtons.measure.order"
                :moduleCode="moduleCode"/>
            <!-- LayerSwitcher -->
            <MapLayerswitcherControl
                v-if="enableLayerSwitcher"
                :posBtnMap="mapButtons.layerswitcher.position"
                :idxBtnMap="mapButtons.layerswitcher.order"
                :moduleCode="moduleCode"/>

            <slot></slot>

            <!-- Link -->
            <MapLinksControl
                v-if="enableLinks"
                :posBtnMap="mapButtons.links.position"
                :idxBtnMap="mapButtons.links.order"
                :showLabelBtnMap="mapButtons.links.showLabel"
                :showButtonOnActionMap="false"
                :moduleCode="moduleCode"/>

            <!-- Backoffice -->
            <MapBackofficeControl
                v-if="enableBackoffice"
                :posBtnMap="mapButtons.backoffice.position"
                :idxBtnMap="mapButtons.backoffice.order"
                :showLabelBtnMap="mapButtons.backoffice.showLabel"
                :collapsible="mapButtons.backoffice.collapsible"
                :collapsed="initialCollapsedExpandCollapse"
                :showButtonOnActionMap="false"
                :moduleCode="moduleCode"/>
            <!-- Draw Features -->
            <!-- <map-drawfeatures-control
                :posBtnMap="POSITION.BOTTOM_RIGHT_VERTICAL"
                :module="moduleCode"/> -->

            <!-- Identify -->
            <MapIdentifyControl
                v-if="enableIdentify"
                data-panel="identify"
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"
                :showBtnMap="false"/>

            <!-- Catalog -->
            <MapCatalogControl
                v-if="enableCatalog"
                data-panel="catalog"
                :moduleCode="moduleCode"
                :showButtonOnActionMap="false"
                :showBtnMap="false"/>

            <!-- Annotations -->
            <MapAnnotationsControl
                v-if="enableAnnotations"
                data-panel="annotations"
                :moduleCode="moduleCode"
                :posBtnMap="mapButtons.annotations.position"
                :idxBtnMap="mapButtons.annotations.order"
                :showLabelBtnMap="mapButtons.annotations.showLabel"
                :collapsible="mapButtons.annotations.collapsible"
                :collapsed="initialCollapsedExpandCollapse"
                :showButtonOnActionMap="false"/>

        </div>
    </div>
</template>
<script>
    import GlobalMixin from '@/app/shared/mixins/global';
    import { GLOBAL, EVENTS } from '@/app/shared/utils/constants';
    import { MapClass } from './MapClass.js';
    import { detectMobile } from "@config/browser";
    import { isEmptyObject } from '@config/utils';

    let map = {};

    export default {
        search: {
            timeout: 6000,
            duration: 1800,
            image: {
                colorBack: [255, 255, 255, .5],
                color: [0, 255, 255, .6],
                width: 5,
                radius: 10,
            },
            stroke: {
                colorBack: [255, 255, 255, .5],
                color: [0, 255, 255, .6],
                width: 8,
            },
            fill: {
                color: [0, 153, 255, .8],
                width: 4,
            },
            layer: 'lyr_search',
            source: 'vs_search',

        },
        mixins: [
            GlobalMixin,
        ],
        components: {
            MapLoading: () => import(/* webpackChunkName: "map-loading" */ '@/app/shared/components/common/LoaderControled'),
            MapFeedbackoptionsControl: () => import(/* webpackChunkName: "map-feedbackoptions-control" */ '@/components/maps/control/feedbackOptionsControl'),
            MapExpandcollapseControl: () => import(/* webpackChunkName: "map-expandcollapse-control" */ '@/components/maps/control/expandControl'),
            MapGeolocationControl: () => import(/* webpackChunkName: "map-geolocation-control" */ '@/components/maps/control/geolocationControl'),
            MapZoomControl: () => import(/* webpackChunkName: "map-zoom-control" */ '@/components/maps/control/zoomControl'),
            MapAttributionControl: () => import(/* webpackChunkName: "map-attribution-control" */ '@/components/maps/control/attributionControl'),
            MapScalelineControl: () => import(/* webpackChunkName: "map-scaleline-control" */ '@/components/maps/control/scaleLineControl'),
            MapScaleboxControl: () => import(/* webpackChunkName: "map-scalebox-control" */ '@/components/maps/control/scaleBoxControl'),
            MapMousepositionControl: () => import(/* webpackChunkName: "map-mouseposition-control" */ '@/components/maps/control/mousePositionControl'),
            MapFullscreenControl: () => import(/* webpackChunkName: "map-fullscreen-control" */ '@/components/maps/control/fullscreenControl'),
            MapStreeviewControl: () => import(/* webpackChunkName: "map-streeview-control" */ '@/components/maps/control/streeviewControl'),
            MapMeasureControl: () => import(/* webpackChunkName: "map-measure-control" */ '@/components/maps/control/measureControl'),
            MapLayerswitcherControl: () => import(/* webpackChunkName: "map-layerswitcher-control" */ '@/components/maps/control/layerSwitcherControl'),
            MapLinksControl: () => import(/* webpackChunkName: "map-links-control" */ '@/components/maps/control/linksControl'),
            MapBackofficeControl: () => import(/* webpackChunkName: "map-backoffice-control" */ '@/components/maps/control/backofficeControl'),
            MapIdentifyControl: () => import(/* webpackChunkName: "map-identify-control" */ '@/components/maps/control/identifyControl'),
            MapCatalogControl: () => import(/* webpackChunkName: "map-catalog-control" */ '@/components/maps/control/catalogControl'),
            MapAnnotationsControl: () => import(/* webpackChunkName: "map-annotations-control" */ '@/components/maps/control/annotationsControl'),
        },
        props: {
            id: {
                type: String,
                required: true
            },
            showLoadingSpin: {
                type: Boolean,
                default: false
            },
            loadInitialy: {
                type: Boolean,
                default: false
            },
            recreateMapOnDestroy: {
                type: Boolean,
                default: false
            },
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            url: {
                type: Object,
                default: () => ({})
            },
            acl: {
                type: Object,
                default: () => ({})
            },
            // mapTools: {
            //     type: Array,
            //     default: ()=> [],
            // },
            activeExpandCollapse: {
                type: Boolean,
                default: false
            },
            initialCollapsedExpandCollapse: {
                type: Boolean,
                default: false
            },
            enableZoom: {
                type: Boolean,
                default: true
            },
            enableGeoLocation: {
                type: Boolean,
                default: true
            },
            enableFullScreen: {
                type: Boolean,
                default: true
            },
            enableLayerSwitcher: {
                type: Boolean,
                default: false
            },
            enableStreetView: {
                type: Boolean,
                default: false
            },
            enableAttribution: {
                type: Boolean,
                default: false
            },
            enableBackoffice: {
                type: Boolean,
                default: false
            },
            enableIdentify: {
                type: Boolean,
                default: false
            },
            enableCatalog: {
                type: Boolean,
                default: false
            },
            enableAnnotations: {
                type: Boolean,
                default: false
            },
            enableScaleLine: {
                type: Boolean,
                default: false
            },
            enableScaleBox: {
                type: Boolean,
                default: false
            },
            enableMousePosition: {
                type: Boolean,
                default: false
            },
            enableMeasure: {
                type: Boolean,
                default: false
            },
            enableLinks: {
                type: Boolean,
                default: false
            },
            mapClass: {
                type: String,
                default: 'map-default',
            },
            // eventCreated: {
            //     type: String,
            //     default: null
            // },
            // eventUpdated: {
            //     type: String,
            //     default: null
            // },
            // eventDeleted: {
            //     type: String,
            //     default: null
            // },
        },
        inject: {
            openMapPanel: { default: null },
            toggleMapPanel: { default: null },
            closeMapPanel: { default: null },
            closeAllMapPanel: { default: null },
        },
        data() {
            return {
                loading: false,
                idFilterTypePanel: 'filtertype',
                groups: [],
            }
        },
        mounted() {
            if(this.loadInitialy) {
                if(!isEmptyObject(this.module)) {
                    this.initializeMapComponent();
                }
            }
        },
        created() {
            this.setEvents(true);
        },
        beforeDestroy() {
            this.setEvents(false);
            this.destroyMap();
        },
        computed: {
            mapId() {
                return this.id;
            },
            loadingMap() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/loadingMap`] : false;
            },
            search() {
                return this.moduleCode ? this.$store.getters.getSearchBox(this.moduleCode) : {};
            },
            userFeature() {
                return  this.moduleCode ? this.$store.getters[`${this.moduleCode}/userFeature`] : {};
            },
            actionMap() {
                return this.moduleCode ? this.$store.getters[`${this.moduleCode}/getActionMap`] : {};
            },
            filterTypePanel(){
                return this.moduleCode ? this.$store.getters.getPanel(this.moduleCode, this.idFilterTypePanel) : {};
            },
            collapsedFilterTypePanel() {
                return !!this.filterTypePanel.collapsed;
            },
            heightFilterTypePanel() {
                return this.filterTypePanel.height;
            },
            module() {
                return this.moduleCode ? this.$store.getters.getModule(this.moduleCode) : {};
            },
            // definitionsMap() {
            //     return this.moduleCode ? this.$store.getters.getMapDefinitions(this.moduleCode) : {};
            // },
            // propertiesMap() {
            //     return this.definitionsMap?.config ?? {};
            // },
            configMap() {
                return this.moduleCode ? this.$store.getters.getConfigMap(this.moduleCode) : {};
            },
            layersProperties() {
                return this.configMap.layers;
            },
            clusterProperties() {
                return this.configMap.layers;
            },
            styleProperties() {
                return this.configMap.style;
            },
        },
        methods: {
            setEvents(flag) {
				if(flag) {
                    this.addEventListen(GLOBAL.MODULE, `${EVENTS.MODULE_LOADED}`, this.onModuleLoaded);

					// if(this.eventCreated) {
					// 	this.addEventListen(this.moduleCode, this.eventCreated, this.onFeatureCreated);
					// }
					// if(this.eventUpdated) {
					// 	this.addEventListen(this.moduleCode, this.eventUpdated, this.onFeatureUpdated);
					// }
					// if(this.eventDeleted) {
					// 	this.addEventListen(this.moduleCode, this.eventDeleted, this.onFeatureDeleted);
					// }
				}else{
                    this.removeEventListen(GLOBAL.MODULE, `${EVENTS.MODULE_LOADED}`, this.onModuleLoaded);

                    // if(this.eventCreated) {
					// 	this.removeEventListen(this.moduleCode, this.eventCreated, this.onFeatureCreated);
					// }
					// if(this.eventUpdated) {
					// 	this.removeEventListen(this.moduleCode, this.eventUpdated, this.onFeatureUpdated);
					// }
					// if(this.eventDeleted) {
					// 	this.removeEventListen(this.moduleCode, this.eventDeleted, this.onFeatureDeleted);
					// }
				}
			},
            onModuleLoaded(params) {
                this.initializeMapComponent(this.configMap, null, true);
            },
            getPanel(params) {
                return this.$store.getters.getPanel(this.moduleCode, params);
            },
            getMapInstance(id) {
                return map[id ? id : this.mapId];
            },
            isMapInitialized(id) {
                return !!this.getMapInstance(id);
            },
            showLoading: function(show = true) {
                this.loading = show
            },
            getValues: function(values) {
                delete values['the_geom']
                return values
            },
            updateBottomTools: function(height) {
                let mobile = detectMobile();
                if(!mobile){
                    const refHeight = height;
                    ['ol-panel-bottom-right-horizontal',
                    'ol-panel-bottom-right-vertical',
                    'ol-panel-bottom-left-horizontal',
                    'ol-panel-bottom-left-vertical'].forEach( key => {
                        let el = $(`.${key}`);
                        if(el){
                            let dataInitial = el.data("btninitial") ? parseInt(el.data("btninitial"), 10) : parseInt(el.css('bottom'), 10) ;
                            if(dataInitial){
                                el.data("btninitial", dataInitial);
                                let hprevious = el.data("hprevious") ? parseInt(el.data("hprevious"), 10) : refHeight;
                                let bottom = hprevious<=refHeight ? refHeight : dataInitial;
                                el.data("hprevious", bottom);
                                el[0].style.setProperty('bottom', `${bottom}px`, 'important');
                            }
                        }
                    });
                }
            },
            onClickMap: function()  {
                // this.closeAllMapPanel();
            },
            onSearch: function(data) {
                const _layerSource = 'searchbox';
                const _map = this.getMapInstance();
                if(!_map){
                    return;
                }

                let category = data?.category;
                let item = data?.item;
                if(!item || !category){
                    _map.clearTemporaryFeature({source: _layerSource});
                    return;
                }

                let categoryEvent = category.showEvent;
                let categoryDetail = category.showDetail;
                let evtData = {
                    code: item?.code,
                    item: item,
                    zoom: true,
                    detail: categoryDetail ?? false
                };

                switch(category.id){
                    case 'mb-oco':
                    case 'cosi-oco':
                    case 'got-ot':
                        this.$eventBus.publish(
                            this.moduleCode,
                            categoryEvent ?? EVENTS.SELECT_FEATURE,
                            evtData
                        );
                        return;
                    case 'addr':
                    case 'pim-patrimony':
                    case 'pim-urbanism':
                    default:
                        if(categoryEvent) {
                            this.$eventBus.publish(
                                this.moduleCode,
                                categoryEvent,
                                evtData
                            );
                        }else{
                            let geom = item?.geom || item?.geojson;
                            if(geom) {
                                _map.drawTemporaryFeature({
                                    source: _layerSource,
                                    data: {
                                        id: item?.id,
                                        geom: geom,
                                        ...item
                                    }
                                });
                            }
                        }
                        break;
                }
            },
            async initializeMapComponent(_data = this.configMap, _callback = undefined, destroy = false) {
                if(this.isMapInitialized()) {
                    if(destroy) {
                        this.destroyMap()
                    }else{
                        return;
                    }
                }

                if(!_data || isEmptyObject(_data)) return;

                if(this.showLoadingSpin) {
                    this.showLoading();
                }

                _callback = _callback ? _callback :
                (_map, _component, _layers) => {
                    // TODO: deixar esse evento dinamico de acordo com o componente do modulo
                    this.$eventBus.listen(
                        this.moduleCode,
                        EVENTS.MAP_RELOAD, this.onMapReload
                    );
                    this.$eventBus.listen(
                        this.moduleCode,
                        EVENTS.MAP_REFRESH, this.onMapRefresh
                    );
                    this.$eventBus.listen(
                        this.moduleCode,
                        EVENTS.HIGHLIGHT_FEATURE, this.onHighlightFeature
                    );
                    this.$eventBus.listen(
                        this.moduleCode,
                        EVENTS.CLEAR_HIGHLIGHT_FEATURE, this.onClearHighlightFeature
                    );
                    this.populateMap(_map, _layers);
                };

                const _dataMap = JSON.parse(JSON.stringify(_data));
                const _configMap = JSON.parse(JSON.stringify(this.configMap));
                await this.initializeMap(_dataMap, _configMap, _callback)
                .then((_map) => {
                    map[this.mapId] = _map;
                });
            },
            async initializeMap(dataMap = {}, configMap = {}, callback = null) {
                let _mapInstance = this.getMapInstance();
                if(_mapInstance) {
                    return _mapInstance;
                }

                return await new MapClass(configMap)
                .setAuthorizationToken(this.$auth.token())
                .createMap(this.mapId, dataMap)
                .then(({mapInstance, mapOl, baseLayers}) => {
                    if(mapOl) {
                        // this.$store.dispatch(`${this.moduleCode}/setConfigMap`, dataMap);
                        this.$store.dispatch(`setConfigMap`, {module: this.moduleCode, config: dataMap});
                        this.$eventBus.publish(
                            this.moduleCode,
                            `map.initialized-${this.mapId}`,
                            {
                                id: this.mapId,
                                map: mapInstance
                            }
                        );
                    }
                    return {mapInstance, mapOl, baseLayers};
                })
                .then(({mapInstance, mapOl, baseLayers}) => {
                    if(mapOl) {
                        return mapInstance
                        .addDefaultLayers(baseLayers)
                        .then(result => {
                            if(callback) {
                                setTimeout(() => {
                                    callback(mapInstance, baseLayers);
                                }, 1500);
                            }

                            if(this.showLoadingSpin) {
                                this.showLoading(false);
                            }
                            return mapInstance;
                        });
                    }
                    if(this.showLoadingSpin) {
                        this.showLoading(false);
                    }
                    return null;
                });
            },
            destroyMap: function(dispatchEvents = true) {
                const data = {id: this.mapId}; //, map: this.getMapInstance()
                const _map = this.getMapInstance();
                if(_map){
                    _map.destroyMap();
                }
                map[data.id] = null;

                if(dispatchEvents) {
                    this.$eventBus.publish(this.moduleCode, 'map.destroyed', data);
                    this.$eventBus.remove(this.moduleCode, 'map.reload', this.onMapReload);
                    this.$eventBus.remove(this.moduleCode, 'map.refresh', this.onMapRefresh);
                }
            },
            onMapReload: function(params = {}) {
                let {map = this.getMapInstance(), layers, ...rest} = params;
                this.populateMap(map, layers, rest);
            },
            onMapRefresh: function(params = {}) {
                let {map = this.getMapInstance(), layers, ...rest} = params;
                if(map) {
                    map.refresh();
                }
            },
            populateMap: function(map, layers, params = {}) {
                this.$eventBus.publish(
                    this.moduleCode,
                    `map.loaddata-${this.mapId}`,
                    {
                        id: this.mapId,
                        map: map,
                        layers: layers,
                        ...params
                        // component: component,
                    }
                );
            },
            addControls2Map: function(config={}) {},
            onHighlightFeature: function(params={}) {
                let {mapId, feature, options={}, ...rest} = params;
                // options = {
                //     ...(this.layersProperties[options.layer ?? 'highlight'] ?? {}),
                //     ...options
                // };

                if(feature && mapId) {
                    let _map = this.getMapInstance(mapId);
                    if(_map) {
                        let drawConfig = {
                            idProperty: options.idProperty ?? 'id',
                            geomProperty: options.geomProperty ?? 'geojson',
                            data: {...feature}
                        };
                        if(options.source) {
                            drawConfig['source'] = options.source;
                        }
                        _map.drawTemporaryFeature(drawConfig);
                    }
                }
            },
            onClearHighlightFeature: function(params={}) {
                let {mapId, feature, options={}, ...rest} = params;
                if(mapId) {
                    let _map = this.getMapInstance(mapId);
                    if(_map) {
                        _map.clearTemporaryFeature(options);
                    }
                }
            },
            // onFeatureCreated(params) {
			// 	this.updateFeatureFromEvent(params, 'created');
			// },
			// onFeatureUpdated(params) {
			// 	this.updateFeatureFromEvent(params, 'updated');
			// },
			// onFeatureDeleted(params) {
			// 	this.updateFeatureFromEvent(params, 'deleted');
			// },
			// updateFeatureFromEvent(params, eventType) {
			// 	const {model_id = null, model = {}} = params;
            //     if()
            //     this.$eventBus.publish(this.moduleCode, EVENTS.FEATURE_UPDATED, {
            //         eventType: eventType,
            //         id: model_id,
            //         model: model,
            //     });
            // },
        },
        watch: {
            heightFilterTypePanel: {
                immediate: false,
                handler(value, oldValue){
                    this.updateBottomTools(value);
                },
            },
            search:{
                deep: true,
                handler: function (value, oldValue) {
                    this.onSearch(value);
                }
            },
        },
    }
</script>
